import React from "react";
import { Link } from "react-router-dom";

import logo from "./img/LTH_IT_LOGO.png";


function Header() {
  return (
    <div className="header">
      <div className="container-fluid">
        <div className="row align-items-center">
          
          {/* Logo */}


          <div className="col-lg-3 d-md-block d-none">
            <div className="brand  ">              
                <img src={logo} alt="Logo"/>        
            </div>
          </div>


           <div className="col-5 d-md-none d-block">
            <div className="brand11 ">              
                <img src={logo} alt="Logo"/ >        
            </div>
          </div>


          <div className="col-lg-9 d-md-block d-none">
            
            {/* Topbar */}
            <div className="topbar ">
              <div className="topbar-col">
                <a href="tel:+919765260001">
                  <i className="fa fa-phone-alt"></i> +91 9765260001
                </a>
              </div>

              <div className="topbar-col">
                <a href="mailto:hr@lthitsolutions.com">
                  <i className="fa fa-envelope"></i> hr@lthitsolutions.com
                </a>
              </div>

              <div className="topbar-col">
                <div className="topbar-social">
                  <a href="#"><i className="fab fa-twitter"></i></a>
                  <a href="#"><i className="fab fa-facebook-f"></i></a>
                  <a href="#"><i className="fab fa-youtube"></i></a>
                  <a href="#"><i className="fab fa-instagram"></i></a>
                  <a href="#"><i className="fab fa-linkedin-in"></i></a>
                </div>
              </div>
            </div>

            {/* Navbar */}
            <div className="navbar navbar-expand-lg bg-light navbar-light pr-5">
              <a href="#" className="navbar-brand "> <h3>  &nbsp;&nbsp;&nbsp;&nbsp;LTH IT SOLUTIONS PVT LTD</h3></a>

              <button
  className="navbar-toggler ml-1"
  type="button"
  data-bs-toggle="collapse"
  data-bs-target="#navbarCollapse"
>
  <span className="navbar-toggler-icon"></span>
</button>

              <div
                className="collapse navbar-collapse justify-content-center"
                id="navbarCollapse"
              >
                <div className="navbar-nav ms-auto pl-5">
                  <Link to="/" className="nav-item nav-link active">Home</Link>
                  <Link to="/about" className="nav-item nav-link">About Us</Link>
                  <Link to="/services" className="nav-item nav-link">Services</Link>
                  <Link to="/portfolio" className="nav-item nav-link">Portfolio</Link>
                  <Link to="/team" className="nav-item nav-link">Team</Link>
                  <Link to="/careers" className="nav-item nav-link">Careers</Link>
                  {/*<Link to="/gallery" className="nav-item nav-link">Gallery</Link>*/}
                  <Link to="/contact" className="nav-item nav-link">Contact Us</Link>

                  {/*<a
                    href="https://htmlcodex.com/bootstrap-agency-template"
                    className="btn"
                  >
                    <i className="fa fa-download"></i> Download Now
                  </a>*/}
                </div>
              </div>
            </div>
          </div>








             <div className="col-1 d-block d-md-none">
             </div>


             <div className="col-6 d-block d-md-none ">
            
            {/* Topbar */}
            <div className="topbar d-md-block d-none">
              <div className="topbar-col">
                <a href="tel:+919765260001">
                  <i className="fa fa-phone-alt"></i> +91 9765260001
                </a>
              </div>

              <div className="topbar-col">
                <a href="mailto:hr@lthitsolutions.com">
                  <i className="fa fa-envelope"></i> hr@lthitsolutions.com
                </a>
              </div>

              <div className="topbar-col">
                <div className="topbar-social">
                  <a href="#"><i className="fab fa-twitter"></i></a>
                  <a href="#"><i className="fab fa-facebook-f"></i></a>
                  <a href="#"><i className="fab fa-youtube"></i></a>
                  <a href="#"><i className="fab fa-instagram"></i></a>
                  <a href="#"><i className="fab fa-linkedin-in"></i></a>
                </div>
              </div>
            </div>

            {/* Navbar */}
            <div className="navbar navbar-expand-sm bg-light navbar-light pr-3">
              <a href="#" className="navbar-brand "></a>

              <button
  className="navbar-toggler ml-5"
  type="button"
  data-bs-toggle="collapse"
  data-bs-target="#navbarCollapse"
>
  <span className="navbar-toggler-icon"></span>
</button>

              <div
                className="collapse navbar-collapse justify-content-center"
                id="navbarCollapse"
              >
                <div className="navbar-nav ms-auto pl-3">
                  <Link to="/" className="nav-item nav-link active">Home</Link>
                  <Link to="/about" className="nav-item nav-link">About Us</Link>
                  <Link to="/services" className="nav-item nav-link">Services</Link>
                  <Link to="/portfolio" className="nav-item nav-link">Portfolio</Link>
                  <Link to="/team" className="nav-item nav-link">Team</Link>
                  <Link to="/careers" className="nav-item nav-link">Careers</Link>
                  {/*<Link to="/gallery" className="nav-item nav-link">Gallery</Link>*/}
                  <Link to="/contact" className="nav-item nav-link">Contact Us</Link>

                  {/*<a
                    href="https://htmlcodex.com/bootstrap-agency-template"
                    className="btn"
                  >
                    <i className="fa fa-download"></i> Download Now
                  </a>*/}
                </div>
              </div>
            </div>

          </div>













        </div>
      </div>
    </div>
  );
}

export default Header;